export default __webpack_public_path__ + "static/media/qr-code-simple-todo.d22eda10.svg";